import React from 'react';

import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';

import Button from 'components/Button';
import ErrorBlock from 'components/ErrorBlock';
import {resendAdminInvitation, fetchStaffMember} from 'ducks/teams';

import './styles.css';

const formSubmit = (_values, _dispatch, props) => {
  const {member} = props;

  props.resendAdminInvitation({adminId: member.id}, [
    () =>
      fetchStaffMember({memberId: member.id}, props.getFetchDataExtraActions())
  ]);
};

const ResendInvitationForm = ({
  disableButton,
  submitting,
  handleSubmit,
  error
}) => (
  <form className="ResendInvitationForm" onSubmit={handleSubmit}>
    {error && <ErrorBlock>{error}</ErrorBlock>}
    <Button
      blue={!submitting}
      className="resendInvitation"
      disabled={submitting || disableButton}
      isLoading={submitting}>
      Resend
    </Button>
  </form>
);

const mapDispatchToProps = {resendAdminInvitation};

const resendInvitationForm = reduxForm({
  form: 'resendInvitation',
  onSubmit: formSubmit
})(ResendInvitationForm);

export default connect(null, mapDispatchToProps)(resendInvitationForm);
